import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    formActions: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "row",
        marginTop: "6rem",
    },
}));
